import {baseApi} from './baseApi';
import {getUserFromLocalStorage} from '../../components/functions/Global';

export const injectedSystemApi = baseApi.injectEndpoints({
    addTagTypes: ['country'],
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: (args) => {
                const {projectId, mapping} = args;

                let url = 'getUsers?project_id=' + projectId;
                if (mapping) {
                    let key = Object.keys(mapping)[0];
                    let value = mapping[key];
                    url += `&${key}=${value}`;
                }

                return {url: url};
            },
            providesTags: ['User']
        })
    }),
});

export const {
    useGetUsersQuery,
} = injectedSystemApi;
